var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.25C5.89137 2.25 1.75 6.39137 1.75 11.5C1.75 16.6086 5.89137 20.75 11 20.75C16.1086 20.75 20.25 16.6086 20.25 11.5C20.25 6.39137 16.1086 2.25 11 2.25ZM0.25 11.5C0.25 5.56294 5.06294 0.75 11 0.75C16.9371 0.75 21.75 5.56294 21.75 11.5C21.75 17.4371 16.9371 22.25 11 22.25C5.06294 22.25 0.25 17.4371 0.25 11.5ZM11 4.75C11.4142 4.75 11.75 5.08579 11.75 5.5V5.81673C13.3804 6.10867 14.75 7.33361 14.75 9C14.75 9.41421 14.4142 9.75 14 9.75C13.5858 9.75 13.25 9.41421 13.25 9C13.25 8.32154 12.6859 7.60339 11.75 7.34748V10.8167C13.3804 11.1087 14.75 12.3336 14.75 14C14.75 15.6664 13.3804 16.8913 11.75 17.1833V17.5C11.75 17.9142 11.4142 18.25 11 18.25C10.5858 18.25 10.25 17.9142 10.25 17.5V17.1833C8.61957 16.8913 7.25 15.6664 7.25 14C7.25 13.5858 7.58579 13.25 8 13.25C8.41421 13.25 8.75 13.5858 8.75 14C8.75 14.6785 9.3141 15.3966 10.25 15.6525V12.1833C8.61957 11.8913 7.25 10.6664 7.25 9C7.25 7.33361 8.61957 6.10867 10.25 5.81673V5.5C10.25 5.08579 10.5858 4.75 11 4.75ZM10.25 7.34748C9.3141 7.60339 8.75 8.32154 8.75 9C8.75 9.67846 9.3141 10.3966 10.25 10.6525V7.34748ZM11.75 12.3475V15.6525C12.6859 15.3966 13.25 14.6785 13.25 14C13.25 13.3215 12.6859 12.6034 11.75 12.3475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.81b31649ac47dfd59293292bc5de593d.svg";
export { ForwardRef as ReactComponent };